<template>
  <div>
    <div v-if="sigfoxStatus.gettingAllSigfoxData" class="text-center mt-5">
      <b-spinner variant="secondary" type="grow"></b-spinner>
    </div>
    <div v-else>
      <b-row class="text-left mb-1"><b-col><strong>Filter:</strong></b-col></b-row>
      <b-row class="mb-3">
        <b-col><b-form-input type="text" v-model="selectVal.benutzerId" placeholder="Benutzer Id"></b-form-input></b-col>
        <b-col><b-form-input v-model="selectVal.device" placeholder="Device"></b-form-input></b-col>
        <b-col><b-button variant="info" class="float-right" v-b-modal.sigfoxMessage>Sigfox Message</b-button></b-col>
      </b-row>
      <b-table striped small responsive outlined :items="filteredData" :fields="fields">
        <template v-slot:cell(karte)="data">
          <a
            :href="`https://www.google.com/maps/place/ + ${data.item.lat} + N, + ${data.item.lng} + E`"
            target="_blank"
            class="btn btn-info btn-sm text-white"
          >Karte</a>
        </template>
      </b-table>
    </div>

    <b-modal id="sigfoxMessage" title="Sigfox Message" size="lg" header-bg-variant="info" header-text-variant="white" hide-footer>
      <b-form @submit.prevent='decode'>
        <b-form-group label="Data">
          <b-input type="text" v-model="message"></b-input>
          <b-button type="submit" variant="info" class="float-right mt-3">Decodieren</b-button>
        </b-form-group>
        <div v-if="sigfoxStatus.decodingSigfoxMessage" class="m-4">
          <b-spinner variant="info" type="grow"></b-spinner>
        </div>
        <div v-else-if="decodedMessage != null" class="my-3">
          <hr class="mb-3">
          <p><strong>Data: </strong> {{ data }}</p>
          <hr>
          <p><strong>Fix: </strong> {{ decodedMessage.fix }} | <strong>Status: </strong> {{ decodedMessage.status }}</p>

          <p class="small">
            <strong>Status 0: </strong>"Normalbetrieb" | <strong>Status 1: </strong>"Notfallbutton gedrückt" | <strong>Status 2: </strong>"Sturz erkannt" | <strong>Status 3: </strong>"Sturz und Notfallbutton"<br>
            <strong>Status 4: </strong>"Transportmodus" | <strong>Status 5: </strong>"Transportmodus und Notfallbutton" | <strong>Status 6: </strong>"Transportmodus und Notfallbutton" <br>
            <strong>Status 8: </strong>"Standbymodus" | <strong>Status 9: </strong>"Standbymodus und Notfallbutton" | <strong>Status 13: </strong>"Box entfernt und Notfallbutton gedrückt" <br>
            <strong>Status 238: </strong>"RTC lost power" | <strong>Status 255: </strong>"Keep Alive"
          </p>

          <hr>

          <p><strong>Hinderniserkennung: </strong> {{decodedMessage.fehlerHinderniserkennung}} | <strong>SD-Karte: </strong> {{decodedMessage.fehlerSdKarte}} | <strong>Soundmodul: </strong> {{decodedMessage.fehlerSoundmodul}} | <strong>RTC Powerloss: </strong> {{decodedMessage.rtcPowerloss}} | <strong>Knopfzellenspannung: </strong> {{decodedMessage.knopfzellenspannungZuGering}}</p>
          <p class="small">1 = Fehler; 0 = Funktioniert</p>

          <hr>

          <p>
            <strong>Lat: </strong> {{ decodedMessage.latitude }} | <strong>Lng: </strong> {{ decodedMessage.longitude }} | 
            <a
              :href="`https://www.google.com/maps/place/ + ${decodedMessage.latitude} + N, + ${decodedMessage.longitude} + E`"
              target="_blank"
              class="btn btn-info btn-sm text-white"
            >Karte</a>
          </p>

          <hr>
          <p><strong>Ladezustand Knopfzelle: </strong> {{decodedMessage.ladezustandKnopfzelle}}</p>
          <p class="small">F = 3,3 V | E = 3,2 V | D = 3,1 V | C = 3,0 V | B = 2,9 V | A = 2,8 V | 9 = 2,7 V | 8 = 2,6 V | 7 = 2,5 V | 6 = 2,4 V | 5 = 2,3 V | 4 = 2,2 V | 3 = 2,1 V | 2 = 2,0 V | 1 = 1,9 V | 0 &lt;= 1,8 V</p>
          <p><strong>Temperatur: </strong> {{ decodedMessage.temperatur }} </p>
          <p class="small">F = 68 °C | E = 64 °C | D = 60 °C | C = 56 °C | B = 52 °C | A = 48 °C | 9 = 44 °C | 8 = 40 °C | 7 = 36 °C | 6 = 32 °C | 5 = 28 °C | 4 = 24 °C | 3 = 20 °C | 2 = 16 °C | 1 = 12 °C | 0 &lt; 12 °C</p>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import moment from 'moment'

export default {
  name: "SigfoxTable",
  computed: {
    ...mapGetters(["allSigfox", "sigfoxStatus"]),
    filteredData() {
      let idFilter = this.allSigfox
      if (this.selectVal.benutzerId !== '') {
        idFilter = this.allSigfox.filter(item => {
            if (!item.benutzerId) {
              item.benutzerId = 'x';
            }
            return (item.benutzerId.toString()).match(this.selectVal.benutzerId)
          })
      }

      let deviceFilter = idFilter
      if(this.selectVal.device !== '') {
        deviceFilter = idFilter.filter(item => {
            return item.device.match(this.selectVal.device)
          }) 
      }

      return deviceFilter
    }
  },
  methods: {
    ...mapActions(['decodeSigfoxMessage']),
    decode() {
      this.decodeSigfoxMessage({"message": this.message})
        .then(res => {
          this.data = this.message
          this.decodedMessage = res
        })
    }
  },
  data() {
    return {
      fields: [
        { key: "karte", label: "Karte" },
        { key: "id", sortable: true },
        { key: "benutzerId", sortable: true },
        "titel",
        { key: "aDate", sortable: true, formatter: value => { return moment(String(value)).format('DD.MM.YYYY HH:mm:ss')} },
        "lat",
        "lng",
        { key: "device", sortable: true },
        "data",
        "deviceTypeId",
        "seqNumber",
        "time"
      ],
      selectVal: {
        benutzerId: '',
        device: ''
      },
      message: '',
      data: '',
      decodedMessage: null
    };
  }
};
</script>

<style>
</style>
